// Components
import { Milhouse } from '../Colors/Primary/Milhouse';

export interface ButtonProps {
  classes?: {
    wrapper?: string;
  };
  color?: object;
  disabled?: boolean;
  label?: string;
  noMargin?: string;
  onClick?: Function;
  secondaryColor?: string;
  variant?: string;
}

export const defaultProps = {
  classes: {
    wrapper: '',
  },
  color: Milhouse,
  disabled: false,
  noMargin: '',
  variant: 'classic',
};
